<svelte:options accessors />

<script context="module" lang="ts">
	export let count = 0;
	/** See: https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill-field */
	import type { TAutocomplete, TAutocompleteLvl2, TextInputType } from './TextInput.svelte';
</script>

<script lang="ts">
	export const InstanceID = count;
	count += 1;
	import { SetValidator, type TValidator, type TValidators } from '$lib/validator';
	import { createEventDispatcher, onDestroy, onMount } from 'svelte';
	import { browser } from '$app/environment';
	import { adjustNotchWidth } from '../utility';
	export let Required = true;
	export let Title: null | string = null;
	export let InsideTitle: null | string = Title;
	export let ShowCount = true; //Add this to config
	export let DBCol = '';
	export let MaxLength = 100;
	export let DBPrefix = '';
	export let AutoComplete: null | TAutocomplete = null;
	export let AutoCompleteLvl2: null | TAutocompleteLvl2 = null;
	export let Value: string = '';
	export let Type: TextInputType = 'text';
	export let OnValid: Function | undefined = undefined;

	//Confirmation Text Association variables:
	//For example if this is the confirm email component then confirmWithEl should be set to the first email component
	export let ConfirmWithEl: any | null = null; //Must be of type TextInputSub
	export let ConfirmEl: any | null = null; //Must be of type TextInputSub
	export let CaseInsensitiveMatch = true;
	//export let OnChange = () => {};
	//export let OnInput = () => {};

	export let ErrorMsg = Required ? 'Required field' : 'Invalid value';
	export let DefaultErrorMsg = ErrorMsg;
	export let Validator: TValidator = null;
	export let ReadOnly: boolean = false;
	export let Disabled: boolean = false;
	let validator: null | TValidators = null;
	export let Valid = false;
	let compOutlineEl: HTMLElement;
	let inputEl: HTMLInputElement;
	let ErrorEl: HTMLElement;
	let labelEl: HTMLLabelElement;
	let notchMiddleEl: HTMLDivElement;
	let inputFocused = false;
	const dispatch = createEventDispatcher()

	onMount(() => {
		if (Validator) {
			validator = SetValidator(Validator, Required, inputEl, setValid, setInvalid, setNuetral);
		}
		if (labelEl && notchMiddleEl && browser) {
			adjustNotchWidth(labelEl, notchMiddleEl);
		}
	});
	export function appendData(formData: FormData) {
		let colName = DBCol;
		if (DBPrefix) {
			colName = DBPrefix + '_' + DBCol;
		}
		console.log('getting formData for', colName);
		formData.append(colName, inputEl.value);
	}
	let touched = false;
	$: if (ConfirmEl != null && ConfirmEl.Value?.toLowerCase() != Value?.toLowerCase()) {
		ConfirmEl.Value = '';
		ConfirmEl.setNuetral();
	}
	function onInput(e: Event) {
		if (validator == null) {
			touched = true;
			if (inputEl.value != '') {
				setNuetral();
			}
		}
	}
	function onChange(e: Event) {}
	function onFocus(e: Event) {
		inputFocused = true;
	}
	export async function validate() {
		console.log('Validate called', InsideTitle, Title);
		Value = inputEl.value;
		if (validator) {
			let validity = validator.Validate();
			if (validity != 'neither') {
				Valid = validity;
			}
		} else {
			if (inputEl.value == '') {
				if (Required) {
					setInvalid();
					Valid = false;
				} else {
					setNuetral();
					Valid = true;
				}
			} else if (inputEl.value.length > MaxLength) {
				setInvalid('Input too long');
				Valid = false;
			} else {
				setValid();
				Valid = true;
			}
		}
		return Valid;
	}
	function onBlur(e: Event) {
		inputFocused = false;
		let otherEl = null;
		let am_i_first = ConfirmWithEl == null && ConfirmEl != null;
		let do_comparison = false;
		if (am_i_first) {
			do_comparison = ConfirmEl.Value != null && ConfirmEl.Value != '';
		} else {
			do_comparison = true;
		}
		if (ConfirmWithEl) {
			otherEl = ConfirmWithEl;
		} else if (ConfirmEl) {
			otherEl = ConfirmEl;
		}
		if (otherEl != null && do_comparison) {
			let match;
			if (CaseInsensitiveMatch) {
				match = otherEl.Value?.toLowerCase() == Value?.toLowerCase();
			} else {
				match = otherEl.Value == Value;
			}
			if (!match) {
				if (otherEl === ConfirmEl) {
					otherEl.setInvalid(`${InsideTitle} does not match ${otherEl.InsideTitle}`);
					setInvalid('');
				} else {
					otherEl.setInvalid('');
					setInvalid(`${InsideTitle} does not match ${otherEl.InsideTitle}`);
				}
				return;
			}
			if (ConfirmWithEl != null && CaseInsensitiveMatch && ConfirmWithEl.Value != Value) {
				console.log('Different casing');
				//Different casing
				if (ConfirmWithEl.Value) {
					Value = ConfirmWithEl.Value;
					inputEl.value = ConfirmWithEl.Value;
				}
			}
		}
		validate();
	}
	export function setNuetral() {
		// if (Required) {
		// 	return;
		// }
		inputEl.classList.remove('is-valid');
		inputEl.classList.remove('is-invalid');
		ErrorEl.style.display = 'none';
	}
	export function setInvalid(msg?: string) {
		console.log('Setting Invalid', InsideTitle);
		Valid = false;
		inputEl.classList.add('is-invalid');
		inputEl.classList.remove('is-valid');
		if (msg != null) {
			ErrorMsg = msg;
		} else {
			ErrorMsg = DefaultErrorMsg;
		}
		if (ErrorMsg) {
			ErrorEl.style.display = 'block';
		} else {
			ErrorEl.style.display = 'none';
		}
	}
	export function setValid() {
		if (ConfirmWithEl && !ConfirmWithEl.Valid) {
			ConfirmWithEl.setValid();
			// if (ConfirmWithEl?.OnValid) {
			// 	ConfirmWithEl.OnValid();
			// }
		}
		dispatch('onValid');
		console.log('setting Valid', InsideTitle);
		Valid = true;
		inputEl.classList.add('is-valid');
		inputEl.classList.remove('is-invalid');
		ErrorEl.style.display = 'none';
		//console.log('OnValid', OnValid, 'typeof OnValid', typeof OnValid);
		if (typeof OnValid == 'function') {
			OnValid();
		}
		//Event.trigger('addressValid');
	}
	function typeAction(el: HTMLInputElement) {
		el.type = Type;
	}
	export function focus() {
		inputEl.focus();
	}
</script>

{#if Title}
	<div class="comp-title">{Title}</div>
{/if}
<div id="TextInput_{DBCol}_form-outline" class="form-outline" bind:this={compOutlineEl}>
	<input
		use:typeAction
		id="TextInput_{DBCol}"
		class="form-control"
		class:active={Value != ''}
		maxlength={MaxLength}
		name={InsideTitle ? InsideTitle : AutoComplete ? AutoComplete : ''}
		autocomplete={AutoComplete
			? AutoCompleteLvl2
				? AutoComplete + ' ' + AutoCompleteLvl2
				: AutoComplete
			: null}
		on:change={onChange}
		on:input={onInput}
		on:blur={onBlur}
		on:focus={onFocus}
		bind:this={inputEl}
		bind:value={Value}
		required={Required}
		readonly={ReadOnly}
		disabled={Disabled}
	/>
	<div class="form-notch">
		<div class="form-notch-leading" style="width: 9px;" />
		<div class="form-notch-middle" style="width: 0px;" bind:this={notchMiddleEl} />
		<div class="form-notch-trailing" />
	</div>
	{#if InsideTitle}
		<label class="form-label" for="TextInput_{DBCol}" style="margin-left: 0px;" bind:this={labelEl}
			>{InsideTitle}</label
		>
	{/if}
	{#if ShowCount && inputFocused}
		<div class="form-helper">
			<div class="form-counter">{Value.length} / 100</div>
		</div>
	{/if}
	<div class="invalid-tooltip" id="TextInput_{DBCol}Error" bind:this={ErrorEl}>{ErrorMsg}</div>
	<div class="msg-spacer" />
</div>
